<script>
import CustomTooltip from '@components/booking/bookingList/custom-tooltip.vue'
export default {
  name: 'HoverClickPopup',
  components: { CustomTooltip },
  props: {
    text: { type: String, default: '' },
  },
  data() {
    return {
      menu: false,
    }
  },
  watch: {
    menu(val) {
      // tell the parent when popup is open or closed
      this.$emit('popup-toggle', val)
    },
  },
}
</script>

<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      left
      :nudge-left="-11"
      :nudge-top="12"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <CustomTooltip :text="$t('general.note')">
          <BaseButton
            class="message-icon"
            :icon="'mdi-message-reply-text-outline'"
            fab
            tertiary
            :border-radius="'8px'"
            :width="'28'"
            :height="'28'"
            v-bind="attrs"
            :ripple="false"
            v-on="on"
          />
        </CustomTooltip>
      </template>
      <v-card class="popup-card">
        <v-list>
          <v-list-item class="list-item">
            <v-list-item-content>
              <v-list-item-title class="client-notes">{{
                $t('general.note')
              }}</v-list-item-title>
              <v-list-item-subtitle class="client-notes-subtitle">{{
                text ? text : '-'
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/hover-click-popup.scss';
</style>
